import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/dialogs/confirm-dialog/confirm-dialog.component';
import { GlobalFunctions } from '@global/GlobalFunctions';

/**
 * Component
 */
@Component({
	selector: 'app-comment-dialog',
	templateUrl: './comment-dialog.component.html',
	styleUrls: ['./comment-dialog.component.scss']
})
export class CommentDialogComponent {
	/** Dialog Form */
	dialogForm: FormGroup;
	/** Header Text */
	public headerText: String
	/** dialogText */
	public dialogText: string
	/** dialogPrompt */
	public dialogPrompt: string
	/** Max Comment Length */
	public maxLength = 200;

	/**
	 * Constructor
	 * @param fb
	 * @param dialogRef
	 * @param data
	 * @param globalFunctions 
	 */
	constructor(
		private fb: FormBuilder,
		public dialogRef: MatDialogRef<CommentDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public globalFunctions: GlobalFunctions
	) {

		this.headerText = data["HeaderText"]
		this.dialogText = data["DialogText"]
		this.dialogPrompt = data["DialogPrompt"] ?? "Comment"
		this.dialogForm = this.fb.group({
			comment: ['', [Validators.required, Validators.maxLength(this.maxLength)]]
		});
	}

	getCommentLength(): number {
		return this.dialogForm.get('comment')?.value.length || 0;
	}

	/**
	 * Cancel button for dialog
	 */
	onCancelClick(): void {
		if (this.dialogForm.dirty) {
			this.globalFunctions.UserConfirm$('Lose any unsaved changes?').subscribe(OKResult => {
				if (OKResult) { this.dialogRef.close(); }
				// do nothing if result is false
			});	
		} else {
			this.dialogRef.close();
		}
	}
}
